/**
 * @desc Export table layout configuration.
 * @example
 * import { dimensions } from 'config/dimensions/client-auth-criteria-grid';
 */
export const dimensions = {
    password: 200,
};
